import React from 'react';
export function EventsSection() {
  return <div className="bg-white py-12" data-id="element-67">
      <div className="max-w-7xl mx-auto px-4" data-id="element-68">
        <div className="flex justify-between items-center mb-8" data-id="element-69">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-70">Eventos</h2>
          <button className="bg-blue-900 text-white px-6 py-2 rounded font-semibold" data-id="element-71">
            Ver todos
          </button>
        </div>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-72">
          <div className="relative h-64 rounded-lg overflow-hidden" data-id="element-73">
            <img src="https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600" alt="Evento Marítimo" className="w-full h-full object-cover" data-id="element-74" />
            <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent flex flex-col justify-end p-6 text-white" data-id="element-75">
              <span className="text-sm mb-2" data-id="element-76">20-22 Novembro, 2024</span>
              <h3 className="text-xl font-bold mb-2" data-id="element-77">Semana Europeia do Mar</h3>
              <button className="bg-white text-blue-900 px-4 py-1 rounded text-sm font-semibold w-fit" data-id="element-78">
                Saber mais
              </button>
            </div>
          </div>
          <div className="relative h-64 rounded-lg overflow-hidden" data-id="element-79">
            <img src="https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=600" alt="Conferência" className="w-full h-full object-cover" data-id="element-80" />
            <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent flex flex-col justify-end p-6 text-white" data-id="element-81">
              <span className="text-sm mb-2" data-id="element-82">5 Dezembro, 2024</span>
              <h3 className="text-xl font-bold mb-2" data-id="element-83">
                Fórum de Inovação Marítima
              </h3>
              <button className="bg-white text-blue-900 px-4 py-1 rounded text-sm font-semibold w-fit" data-id="element-84">
                Saber mais
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}